import { render, staticRenderFns } from "./EbsInfo.vue?vue&type=template&id=1521bdaa&scoped=true&"
import script from "./EbsInfo.vue?vue&type=script&lang=ts&"
export * from "./EbsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./EbsInfo.vue?vue&type=style&index=0&id=1521bdaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1521bdaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
